export default {
  SET_HOVERED_EVENT_ID: 'setHoveredEventId',
  SET_EDITED_EVENT: 'setEditedEvent',
  SET_UTIL_DATA: 'setUtilData',
  SET_EVENT_EDIT_TYPE: 'setEventEditType',
  UPDATE_EDITED_EVENT: 'updateEditedEvent',
};
